export default "__VITE_ASSET__9e82b742__"